import React, { useEffect } from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        flexDirection: "row",
        backgroundColor: "white",
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 20,
    },
    section: {
        margin: 5,
        padding: 5,
        flexGrow: 1,
        borderStyle: "solid",
    },
    tableData: {
        display: "table",
        width: "100%",
        borderStyle: "solid",
        borderWidth: 0.5,
        marginBottom: 40,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCol: {
        width: "100%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableColSrno: {
        width: "30%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableColRemark: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableColSrnumber: {
        width: "19%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableColTenure: {
        width: "17%",
        borderStyle: "solid",
        borderWidth: 0.5,
    },
    tableCell: {
        margin: "auto",
        fontSize: 10,
        flexDirection: "col",
    },
    heading: {
        width: 200,
        fontWeight: "bold",
        marginTop: 10,
        marginBottom: 20,
        marginLeft: 280,
    },
    date: {
        width: 200,
        borderStyle: "solid",
        marginBottom: 45,
        fontSize: 15,
        marginLeft: "73%",
        fontWeight: "normal",
    },
    rangeDate: {
        width: 350,
        borderStyle: "solid",
        marginBottom: 7,
        fontSize: 15,
        fontWeight: "normal",
    },
    nextRangeDate: {
        width: 450,
        borderStyle: "solid",
        marginBottom: 50,
        fontSize: 15,
        fontWeight: "normal",
    },
});

function PrintSheet({ analytics }) {
    const currentDate = new Date();

    useEffect(() => { });

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap={true} orientation="landscape">
                <View style={styles.section}>
                    <Text style={styles.heading}>Reminder Date Sheet</Text>
                    <Text style={styles.date}>{currentDate.toLocaleString()}</Text>
                    <Text style={styles.rangeDate}>
                        Alert Date Range: From: <Text style={{ fontStyle: "italic" }}>{analytics.formData.fromDate}</Text> - To: <Text style={{ fontStyle: "italic" }}>{analytics.formData.toDate}</Text>
                    </Text>
                    <Text style={styles.nextRangeDate}>
                        Next Start Date Range: From: <Text style={{ fontStyle: "italic" }}>{analytics.next_from_date}</Text> - To: <Text style={{ fontStyle: "italic" }}>{analytics.next_to_date}</Text>
                    </Text>
                    <View style={styles.tableData}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColSrnumber}>
                                <Text style={styles.tableCell}>Sr.no</Text>
                            </View>
                            <View style={styles.tableColSrnumber}>
                                <Text style={styles.tableCell}>Order ID</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>First Name</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>Last Name</Text>
                            </View>
                            {/* <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>Start Date</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>End Date</Text>
                            </View> */}
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>Next Start Date</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>Mobile</Text>
                            </View>
                            <View style={styles.tableColSrno}>
                                <Text style={styles.tableCell}>Alert Date</Text>
                            </View>
                            <View style={styles.tableColTenure}>
                                <Text style={styles.tableCell}>Tenure</Text>
                            </View>
                            <View style={styles.tableColRemark}>
                                <Text style={styles.tableCell}>Remark</Text>
                            </View>
                        </View>
                        {analytics.pdfData.map((result, index) => (
                            <View style={styles.tableRow} key={index}>
                                <View style={styles.tableColSrnumber}>
                                    <Text style={styles.tableCell}>{index + 1}</Text>
                                </View>
                                <View style={styles.tableColSrnumber}>
                                    <Text style={styles.tableCell}>{result.order_id}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.first_name}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.last_name}</Text>
                                </View>
                                {/* <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.carefill_start_date}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.carefill_end_date}</Text>
                                </View> */}
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.next_start_date}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.mobile_number}</Text>
                                </View>
                                <View style={styles.tableColSrno}>
                                    <Text style={styles.tableCell}>{result.alert_date}</Text>
                                </View>
                                <View style={styles.tableColTenure}>
                                    <Text style={styles.tableCell}>{result.refill_cycle}</Text>
                                </View>
                                <View style={styles.tableColRemark}>
                                    <Text style={styles.tableCell}></Text>
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
            </Page>
        </Document>
    );
}
export default PrintSheet;
